import { createServerFn } from '@tanstack/react-start'
import type { JobFrontmatter, JobListItem } from './types'

export type { JobFrontmatter, JobListItem }

const componentModules = import.meta.glob('../content/jobs/*.{md,mdx}') as Record<string, () => Promise<any>>

export function getJobComponent(slug: string) {
  for (const [path, load] of Object.entries(componentModules)) {
    const file = path.split('/').pop() ?? path
    const base = file.replace(/\.(md|mdx)$/i, '')
    if (base === slug) {
      return load
    }
  }
  return null
}

export const getJobs = createServerFn({ method: 'GET' }).handler(async () => {
  const { fetchJobs } = await import('./jobs.server')
  return fetchJobs()
})

export const getJobBySlug = createServerFn({ method: 'GET' })
  .inputValidator((slug: string) => slug)
  .handler(async (ctx: any) => {
    const { fetchJobBySlug } = await import('./jobs.server')
    return fetchJobBySlug(ctx.data)
  })
